import { Fragment, useState } from 'react';

import { IconButton } from '../../cdl/IconButton/IconButton';
import { translate } from '../../common/helpers/translate.helper';
import { IconArrowBackUp } from '../../common/icons/cdl/ArrowBackUp';
import { RestoreAgentConfirmPopup } from '../detail/components/RestoreAgentConfirmPopup';

export const RestoreAgentPopupButton = ({ onConfirm, name }) => {
    const [showConfirmPopup, setShowConfirmPopup] = useState(false);

    const handleOnConfirm = () => {
        setShowConfirmPopup(false);
        onConfirm();
    };

    const handleOnClick = (e) => {
        setShowConfirmPopup(true);
        e.stopPropagation();
    };

    return (
        <Fragment>
            <IconButton
                Icon={IconArrowBackUp}
                onClick={handleOnClick}
                tooltipLabel={translate('agents.restoreButton.headline')}
                aria-label="Restore"
            />
            <RestoreAgentConfirmPopup
                isOpen={showConfirmPopup}
                onSubmit={handleOnConfirm}
                onDismiss={() => setShowConfirmPopup(false)}
                name={name}
            />
        </Fragment>
    );
};
